import { render, staticRenderFns } from "./invoice-fail.vue?vue&type=template&id=5a1469d2&scoped=true&"
import script from "./invoice-fail.vue?vue&type=script&lang=js&"
export * from "./invoice-fail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-fail.vue?vue&type=style&index=0&id=5a1469d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1469d2",
  null
  
)

export default component.exports